import React from 'react';
import {Image, ImageProps} from "../image/image";
import {DeviceViewModel} from "../../models/device.view-model";
import {UseIoC} from "../composers/composer-plugins/use-ioc";
import {EventTypeViewModel} from "../../../domain/common/events/models/event-type-view-model";
import {EventIconComposer} from "./event-icon.composer";
import {THEME} from "../../app/consts";

export class EventIconProps extends ImageProps {
  device: DeviceViewModel;
  event: EventTypeViewModel;
  style: Object;
  width: Number;
  height: Number;
  eager: Boolean;
  onLoad: Function;
  fallbackImage: String;
  onError: Function;
  className: String;
  theme: THEME;
}

export const EventIcon = UseIoC()(EventIconComposer((props: EventIconProps) => {
  if (!props.event) {
    return null;
  }

  const style = {...props.style};

  !style.maxWidth && (style.maxWidth = props.width || props.style.width);
  !style.maxHeight && (style.maxHeight = props.height || props.style.height);
  style.width = 'auto';
  style.height = 'auto';

  const imageProps: ImageProps = {
    src: props.src,
    style,
    eager: props.eager,
    className: props.className,
    onLoad: () => props.onLoad && props.onLoad(),
    onError: () => props.onError && props.onError(),
    width: props.width,
    height: props.height,
    theme: props.theme
  };

  return <Image {...imageProps}/>;
}));
